import { Component, ComponentFactoryResolver, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { AspHomeService } from '../asp-home/asp-home.service';
import { ToastrService } from 'ngx-toastr';
import { AspInstantOrderQuoteComponent } from '../asp-instant-order-quote/asp-instant-order-quote.component';
import { Router } from '@angular/router';
import { AspInstantOrderQuoteService } from '../asp-instant-order-quote/asp-instant-order-quote.service';
import { AspLoadingService } from '../asp-loading/asp-loading.service';
import { MatSelect } from '@angular/material/select';
import { AspMyItemListService } from '../asp-my-item-list/asp-my-item-list.service';
import { SearchSuggestionService } from 'app/shared/search-suggestion.service';
import { ChangeDetectorRef } from '@angular/core';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-asp-instant-request',
  templateUrl: './asp-instant-request.component.html',
  styleUrls: ['./asp-instant-request.component.scss']
})
export class AspInstantRequestComponent implements OnInit {
  selectedKitName: string = '';
  isVisible: boolean;
  carNumber:string = '';
  showError: boolean;
  vehicleData: any;
  isOpenFull: boolean;
  openPartsEntry: boolean;
  openReview: any;
  manuallySelect: boolean;
  selectedKits: any
  itemList: any;
  kits: any;
  showError1: boolean;
  suggestionMap: { [key: string]: { name: string; id: number } } = {};
  items: any;
  itemSet: { name: string; quantity: number; }[];
  response: Object;
  suggestResponse: any;
  notFound: boolean;
  popupContainer: boolean;
  showModal: boolean;
  searchTextName: string;
  asTypedPart: any;
  searchTextShow: boolean;
  suggestions: any;
  isPopupOpen: boolean;
  successIcon: string = '../../../../assets/icons/icons8-ok.gif';
  selectedSuggestion: any;
  isRequestExistsPopupOpen: boolean = false;
  existingRequest: any = null;
  showFullItems: boolean = false; 
  existingRequestId: any;
  updatePopupData: any = null; 
  existingregistrationNumber: any;
  regNo: any;
  activeUrl: string;
  isRequestDetails: boolean;
  addMoreItemsId: string;
  isRequestDetailsPage: boolean;
  selectedImages: File[] = [];
  imagePreviews: string[] = [];
  spareRequestId!: number;
  previewImageUrl: string | null = null;
  imagePreviewOpen = false;
  fromClutchFlow: boolean = false;
  isEditRequest: boolean = false;
  isLockedPopupOpen = false;
  isDeleteMode: boolean;
  lockedItemIds: number[] = [];
  lockedItemNames: any;
  removedItems = new Set<number>();
  requestItems: any[] = [];
  requestId: any;
  removedPartIds: any[] = [];
  showLastItemDeletePopup = false;
  lastItemDeleteIndex: number | null = null;
  lastItemName = '';
  modifiedItems: Set<string> = new Set<string>();
  showRequestCancelSuccessPopup = false;
  cancelledItemName: any = null;
  cancelledRequestId: any;
  selectedLockedPart: any;
  
  constructor(
    private homeService:AspHomeService,
    public toastr: ToastrService,
    private resolver: ComponentFactoryResolver,
    private router: Router,
    private aspInstantOrderQuoteService: AspInstantOrderQuoteService,
    private aspLoadingService: AspLoadingService,
    private aspMyItemListService: AspMyItemListService,
    public searchSuggestionService:SearchSuggestionService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
     this.selectedKitName = localStorage.getItem('selectedKitName') || 'Clutch';
    this.carNumber=localStorage.getItem("carNumber");
    // console.log("carNumber",this.carNumber)
      // const cartCountEl = document.getElementsByClassName('animate-cta')[0] as HTMLElement;

  // To hide
  // cartCountEl.style.display = 'none';
  this.getKitNames();
  // this.checkExistingRequest();
  // localStorage.removeItem('requestId')

  }
openSidebar(hide){ 
  // const cartCountEl = document.getElementsByClassName('animate-cta')[0] as HTMLElement;
  // cartCountEl.style.display = 'block';
  this.isVisible=hide;
  localStorage.removeItem('instantOrder');
  // localStorage.removeItem('carNumber');

      if ((hide== false || hide== 'false') && localStorage.getItem('instantOrder') && localStorage.getItem('instantOrder') === '1') {
      this.clearLocalStorage()
    }
    if (hide === false || hide === 'false') {
      localStorage.removeItem('clutchFlow');
      //  localStorage.removeItem('source');
    }
  //   if (hide === false || hide === 'false') {
  //   localStorage.removeItem('selectedKitName');
  // }
}
clearLocalStorage(){
      localStorage.removeItem('instantOrder');
      localStorage.removeItem('rowKey');
      localStorage.removeItem('selectedMake');
      localStorage.removeItem('selectedModel');
      localStorage.removeItem('selectedYear');
      localStorage.removeItem('variant');
      localStorage.removeItem('variantKey');
      localStorage.removeItem('fuelType');
      localStorage.removeItem('clutchFlow');
      localStorage.removeItem('selectedKitName');
      localStorage.removeItem('source');
}

onCarNumberInput(event: Event): void {
  const input = (event.target as HTMLInputElement).value;
  this.carNumber = this.formatRegNo(input);
}

formatRegNo(value: string): string {
  value = value.replace(/\s+/g, '').toUpperCase();

  if (value.length > 2) {
    value = value.slice(0, 2) + ' ' + value.slice(2);
  }
  if (value.length > 5) {
    value = value.slice(0, 5) + ' ' + value.slice(5);
  }
  if (value.length > 8) {
    value = value.slice(0, 8) + ' ' + value.slice(8);
  }
  return value;
}

onFindMyCar(): void {
  if (!this.carNumber || this.carNumber.trim() === '') {
    this.showError = true;
  } else {
    
      this.aspLoadingService.show();
    localStorage.setItem('carNumber',this.carNumber);
    this.showError = false;
    
    this.homeService.regDecode(this.carNumber.replace(/\s/g, "")).subscribe(
      res => {
        
      this.aspLoadingService.hide();
        // console.log("regdecorresponse",res)
        if(res['code']==200){
          // this.vehicleInfo = true; 
          localStorage.setItem('source', 'REG_NUMBER_DECODE');
          this.isOpenFull=true;
          this.vehicleData = res['data']; 
          localStorage.setItem("registrationNumber",this.vehicleData.registrationNumber.replace(/"/g, ''));

          if (!this.vehicleData?.variant) {
            localStorage.setItem('source', 'MANUAL');
            localStorage.setItem("selectedMake", res['data']?.make);
            localStorage.setItem("selectedModel", res['data']?.model);
            localStorage.setItem("selectedYear", res['data']?.year);
            localStorage.setItem("rowKey", res['data']?.rowKey);
            localStorage.setItem("variant", res['data']?.variant);
            this.redirectToManualVariantSelection();
          }

        }else{
          this.notFound=true;
          this.toastr.error(res['data']['description'], 'Error');  
           localStorage.setItem('source', 'MANUAL');
          // this.redirectToManualSelection();
          // this.redirectToManualVariantSelection();
        }
      },
       error => {
         this.aspLoadingService.hide();
        this.toastr.error(
          error?.error?.data?.description || 'Something went wrong',
          'Error'
        );

        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    );
    // Continue your logic here
    // console.log('Finding car for:', this.carNumber);
  }
}
closeDetails(hide){
  if (this.isLockedPopupOpen) {
    return;
  }
  this.isOpenFull=hide;
   if(localStorage.getItem('instantOrder')  && localStorage.getItem('instantOrder') == '2'){
      this.vehicleData = {
        make: localStorage.getItem('selectedMake') || '',
        model: localStorage.getItem('selectedModel') ||'',
        variant: localStorage.getItem('variant') || '',
        year: localStorage.getItem('selectedYear') || '',
        fuel: localStorage.getItem('fuelType') || '',
        variantKey:localStorage.getItem('variantKey')|| '',
        rowKey:localStorage.getItem('rowKey')||''
      }
   }
}
closetext(hide){
    if (this.isLockedPopupOpen) {
      return;
    }

    this.openPartsEntry=hide;
       if(localStorage.getItem('addMoreItemsId')){        
      this.addMoreItemsId=localStorage.getItem('addMoreItemsId')
      this.vehicleData = {
        make: localStorage.getItem('selectedMake') || '',
        model: localStorage.getItem('selectedModel') ||'',
        variant: localStorage.getItem('variant') || '',
        year: localStorage.getItem('selectedYear') || '',
        fuel: localStorage.getItem('fuelType') || '',
        variantKey:localStorage.getItem('variantKey')|| '',
        rowKey:localStorage.getItem('rowKey')||''
      }
   }
}
carDetails = [
  { label: 'Make', valueKey: 'make' },
  { label: 'Model', valueKey: 'model' },
  { label: 'Variant', valueKey: 'variant' },
  { label: 'MFG Year', valueKey: 'year' },
  { label: 'Fuel', valueKey: 'fuel' },
  { label: 'VIN', valueKey: 'vin' },
  { label: 'Generation', valueKey: 'generation' },
  { label: 'Vehicle Type', valueKey: 'vehicleType' },
];
// confirmCar(){
//   this.openPartsEntry=true;
//   this.openCustomPanel=false;
// }
  confirmCar() {

    // if (this.fromClutchFlow) {

    //   localStorage.setItem('registrationNumber', this.carNumber);
    //   localStorage.setItem('rowKey', this.vehicleData?.rowKey);
    //   localStorage.setItem('variantKey', this.vehicleData?.variantKey);

    //   localStorage.setItem('clutchkitFlow', '1');

    //   this.openSidebar(false); // ✅ close sidebar
    //   this.router.navigate(['clutch-kit-details', 'clutchkit', 'decode']);
    //   return;
    // }
    // const isClutchFlow = localStorage.getItem('clutchFlow') === '1';
    const selectedKitName = localStorage.getItem('selectedKitName');
    const isKitFlow = !!selectedKitName;
    // if (isClutchFlow) {

    //   // ✅ Store full vehicle data (IMPORTANT)
    //   localStorage.setItem('vehicleData', JSON.stringify(this.vehicleData));

    //   // ✅ Individual fields (optional but safe)
    //   localStorage.setItem('registrationNumber', this.carNumber || '');
    //   localStorage.setItem('rowKey', this.vehicleData?.rowKey || '');
    //   localStorage.setItem('variantKey', this.vehicleData?.variantKey || '');
    //   localStorage.setItem('selectedMake', this.vehicleData?.make || '');
    //   localStorage.setItem('selectedModel', this.vehicleData?.model || '');
    //   localStorage.setItem('selectedYear', this.vehicleData?.year || '');
    //   localStorage.setItem('fuelType', this.vehicleData?.fuel || '');
    //   localStorage.setItem('variant', this.vehicleData?.variant || '');

    //   this.openSidebar(false);

    //   this.router.navigate(['clutch-kit-details', 'clutchkit', 'decode']);
    //   return;
    // }
    if (isKitFlow) {

      localStorage.setItem('vehicleData', JSON.stringify(this.vehicleData));

      localStorage.setItem('registrationNumber', this.carNumber || '');
      localStorage.setItem('rowKey', this.vehicleData?.rowKey || '');
      localStorage.setItem('variantKey', this.vehicleData?.variantKey || '');

      localStorage.setItem('selectedMake', this.vehicleData?.make || '');
      localStorage.setItem('selectedModel', this.vehicleData?.model || '');
      localStorage.setItem('selectedYear', this.vehicleData?.year || '');

      localStorage.setItem('fuelType', this.vehicleData?.fuel || '');
      localStorage.setItem('variant', this.vehicleData?.variant || '');

      this.openSidebar(false);
      console.log(
  'Before Navigate:',
  localStorage.getItem('selectedKitName')
);
      this.router.navigate([
        'kit-details',
        selectedKitName.toLowerCase().replace(/\s+/g, '-'),
        'decode'
      ]);

      return;
    }
    this.openPartsEntry = true;
    this.openCustomPanel = false;
  }
text: string = '';

startVoiceRecognition() {
  const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
  
  if (!SpeechRecognition) {
    alert('Speech Recognition not supported in this browser.');
    return;
  }

  const recognition = new SpeechRecognition();
  recognition.lang = 'en-US';
  recognition.interimResults = false;
  recognition.maxAlternatives = 1;

  recognition.start();

  recognition.onresult = (event: any) => {
    const speechText = event.results[0][0].transcript;
    this.text += (this.text ? ' ' : '') + speechText;
  };

  recognition.onerror = (event: any) => {
    console.error('Speech recognition error:', event.error);
  };
}

// deletePart(item) {
//   const name = item.name.trim();
//   let wishlist: { name: string, quantity: number }[] = this.itemSet

//   const index = wishlist.findIndex(w => w.name.toLowerCase() === name.toLowerCase());

//   wishlist.splice(index, 1); 
//   item.inWishlist = false;   
        
//   this.itemSet=wishlist;
//   const itemsArray = this.itemList.split(', ');

//   // Remove the item
//   const filteredArray = itemsArray.filter(item => item.trim() !== name);

//   // Convert back to string
//   this.itemList = filteredArray.join(', ');
//   // console.log("itemList",this.itemList)
// }
  @ViewChild('magicQuote', { read: ViewContainerRef }) container!: ViewContainerRef;

redirectToManualSelection(){
   localStorage.setItem('instantOrder', '1');
   localStorage.setItem('request','1');
  this.router.navigate(['/make']);
  this.manuallySelect=true;
  this.isVisible=false;
  this.isVisible=false;
  this.notFound=false;
  localStorage.removeItem('vin');
  localStorage.removeItem('vinNumber');
}
redirectToManualVariantSelection(){
  localStorage.setItem('instantOrder', '1');
   localStorage.setItem('request','1');
  this.router.navigate(['/variant']);
  this.manuallySelect=true;
  this.isVisible=false;
  this.isVisible=false;
  this.notFound=false;
  localStorage.removeItem('vin');
  localStorage.removeItem('vinNumber');
}
getVehicleValue(key: string): any {
  return this.vehicleData && this.vehicleData[key];
}

hasVehicleValue(key: string): boolean {
  return this.vehicleData && this.vehicleData[key] !== null && this.vehicleData[key] !== undefined;
}
onImageSelected(event: any): void { 
    const file = event.target.files[0];
    
      this.aspLoadingService.show();
      this.aspInstantOrderQuoteService.uploadCarImage(file).subscribe(
        (res) => {
          this.aspLoadingService.hide();
          if(res['data'].registrationNumber){
            // console.log('Car details:', res);
            this.vehicleData = res['data'];
            localStorage.setItem("registrationNumber",this.vehicleData.registrationNumber.replace(/"/g, ''));
            this.carNumber=res['data'].registrationNumber;
            this.isOpenFull=true;
          }else{
            localStorage.setItem('carNumber',res['data'].plateNumber);
            this.carNumber=res['data'].plateNumber;
            // console.log("plateNumber",this.carNumber);
            this.notFound=true;
            this.toastr.error('Invalid registration number', 'Error'); 
          }
          event.target.value = '';
        },
        (err) => {
          console.error('Upload error:', err);
        }
      );
  }
  notFoundClose(){
   this.notFound=false;
  }

  triggerFileInput(fileInput: HTMLInputElement): void {
    fileInput.click();
  }
  private kitItemMap: Map<string, string[]> = new Map();
   onKitsChanged() {
    // Save current selection into localStorage
    // localStorage.setItem('selectedKits', JSON.stringify(this.selectedKits));
  
    // Clear and rebuild kitItemMap
    this.kitItemMap.clear();
    for (let kit of this.selectedKits) {
      this.kitItemMap.set(kit.name, kit.items);
    }
  
    // Combine all kit items and update textarea
    this.updateItemListFromKits();
  
    // console.log("selectedKits (after change)", this.selectedKits);
  }
  removeKit(kit: any) {
    // console.log("kit", kit);
  
    // 1️⃣ Remove kit from selectedKits
    this.selectedKits = this.selectedKits.filter(k => k !== kit);
  
    // 2️⃣ Delete kit from kitItemMap
    this.kitItemMap.delete(kit.name);
  
    // 3️⃣ Remove kit items from itemList
    const kitItemsToRemove = kit.items.map(item => item.trim().toLowerCase());
  
    const currentItems = (this.itemList ?? '')
      .split(/\s*[\n,]\s*/)  // Split by comma OR newline (ignore spaces)
      .map(item => item.trim())
      .filter(item => item.length > 0);
  
    // Remove all kit items (case-insensitive match)
    const updatedItems = currentItems.filter(item => !kitItemsToRemove.includes(item.toLowerCase()));
  
    // 4️⃣ Update itemList
    this.itemList = updatedItems.join(',');
  
    // Optional: Also update the view cleanly (but not strictly needed here)
    this.updateItemListFromKits();
  }
    closeSelectPanel(select: MatSelect) {
      select.close();
    }
     onItemListChanged() {
    // Normalize current itemList into lowercase array (support comma or newline)
    const itemListArray = (this.itemList ?? '')
      .split(/\s*[\n,]\s*/)   // Support comma **or** newline
      .map(item => item.trim().toLowerCase())
      .filter(item => item.length > 0);
  
    // If text area is completely empty, don't clear all kits aggressively
    if (itemListArray.length === 0) {
      return; // Do nothing for now
    }
  
    // Only remove kits whose ALL items are missing from textarea
    const stillSelectedKits = this.selectedKits.filter(kit => {
      const hasAtLeastOneItem = kit.items.some(kitItem =>
        itemListArray.includes(kitItem.trim().toLowerCase())
      );
      return hasAtLeastOneItem;
    });
  
    if (stillSelectedKits.length !== this.selectedKits.length) {
      this.selectedKits = stillSelectedKits;
  
      // Rebuild kitItemMap cleanly
      this.kitItemMap.clear();
      for (let kit of this.selectedKits) {
        this.kitItemMap.set(kit.name, kit.items);
      }
    }
  }
   updateItemListFromKits() {
    const toTitleCase = (str: string) =>
      str.split(' ')
         .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
         .join(' ');
  
    const normalize = (str: string) => str.trim().toLowerCase();
  
    // Parse textarea items
    const currentItems = (this.itemList ?? '')
      .split(/\s*[\n,]\s*/)
      .map(item => normalize(item))
      .filter(item => item.length > 0);
  
    // Get all selected kit items (flattened and normalized)
    const selectedKitItems = ([] as string[]).concat(...Array.from(this.kitItemMap.values()))
      .map(item => normalize(item));
  
    // Keep manually typed items that are not from kits, or still match selected kits
    const finalItems = currentItems.filter(item =>
      selectedKitItems.includes(item) || !this.isItemFromAnyKit(item)
    );
  
    // Merge and remove duplicates
    const merged = Array.from(new Set([...finalItems, ...selectedKitItems]));
  
    // Format (title-case) and output
    this.itemList = merged
      .map(toTitleCase)
      .join('\n'); // If you don’t want sorted order, remove `.sort(...)`
  }
   isItemFromAnyKit(item: string): boolean {
    return this.kits.some(kit =>
      kit.items.some(kitItem => kitItem.trim().toLowerCase() === item)
    );
  }
   getKitNames(){
     this.aspMyItemListService.kitItemNames().subscribe(res =>{
// console.log("res",res);
if(res['code']== 200){
let result =JSON.parse(JSON.stringify(res));
this.kits = result.data.kitNames.map((kitName: string) => {
    return {
      name: kitName,
      items: result.data[kitName] || []
    };
  });

  // console.log('Updated kits:', this.kits);
     
      
    const normalizedSearchItems = (this.itemList ?? '')
      .split(/\s*[\n,]\s*/)
      .map(item => item.trim().toLowerCase())
      .filter(item => item.length > 0);
     this.selectedKits = this.kits.filter(kit =>
      kit.items.some(kitItem =>
        normalizedSearchItems.includes(kitItem.trim().toLowerCase())
      )
    );
    this.kitItemMap.clear();
    for (let kit of this.selectedKits) {
      this.kitItemMap.set(kit.name, kit.items);
    }
    }
  })
  }
  reviewParts(hide){
    
    if(hide==true){
      if (this.isEditRequest && this.itemSet?.length > 0) {
      return;
    }
      if (!this.itemList) {
        this.showError1 = true; 
      } 
      else 
      {
        // this.itemList = this.formatText(this.itemList);
        if (!this.isEditRequest) {
          this.itemList = this.formatText(this.itemList);
        }
        this.getItemList(hide) 

        console.log("this.itemList", this.itemList);

        // let wishlist: { name: string, quantity: number }[] = JSON.parse(sessionStorage.getItem('wishlist') || '[]');
        let wishlist: { name: string, quantity: number }[] = [];

        const itemList = this.itemList.split(','); // split by comma
        console.log('itemSet after reviewParts', this.itemSet);

      for (let item of itemList) {
        const trimmed = item.trim();
        if (trimmed) {
          const name = trimmed
            .split(/\s+/)
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');

          wishlist.push({ name, quantity: 1 });
        }
        console.log('wishlist before itemSet assignment', wishlist);
        this.itemSet=wishlist;
        console.log('itemSet after assignment', this.itemSet);
      }
    }
    }else{
      this.openReview=hide;
       this.openReview = false;
    }
  }
  formatText(text: string): string {
    const items = text
      .split(/[\n,]+/) 
      .map(item => item.trim()) 
      .filter(item => item !== '');
  
    const seen = new Set<string>();
    const uniqueItems = items.filter(item => {
      const lower = item.toLowerCase();
      if (seen.has(lower)) {
        return false;  // Duplicate (case-insensitive)
      }
      seen.add(lower);
      return true;  // First time seen
    });
  
    return uniqueItems.join(', ');
  }

  getItemList(hide){
  this.aspLoadingService.show(); 
  let garageKey = localStorage.getItem('garageKey');
  const relevancyCount = 3;
   this.aspInstantOrderQuoteService
      // .getSuggest(relevancyCount, this.vehicleData.variantKey, this.itemList, garageKey)
      .getSuggest(this.itemList) 
      .subscribe((result) => {
        this.aspLoadingService.hide(); 
      // console.log("result",result)
      this.suggestResponse=result;
      if (result.code == 200) {
        
        this.openReview=hide;
         const suggestionMap: { [key: string]: { name: string; id: number } } = {};

const searchArray = Array.isArray(this.itemList) ? this.itemList : this.itemList.split(',');

searchArray.forEach((rawItem: string) => {
  const item = rawItem.trim().toLowerCase();
  const value = result.details[rawItem.trim()];

  if (value) {
    if (typeof value === 'object' && !Array.isArray(value)) {
      const innerKeys = Object.keys(value);
      const name = innerKeys.length > 0 ? innerKeys[0].trim().replace(/,/g, ' ') : rawItem.trim().replace(/,/g, ' ');
      const id = value[innerKeys[0]];

      suggestionMap[item] = { name, id };
    } else if (Array.isArray(value) && value.length > 0) {
      const firstItem = value[0];
      const name = (firstItem.name?.trim() ?? rawItem.trim()).replace(/,/g, ' ');
      const id = firstItem.id ?? 0;

      suggestionMap[item] = { name, id };
    }
  } else {
    const fallback = rawItem.trim().replace(/,/g, ' ');
    suggestionMap[item] = { name: fallback, id: 0 };
  }
});
    this.suggestionMap= suggestionMap;
    // console.log("suggestionMap",this.suggestionMap);

     this.suggestionMap = this.suggestionMap ? this.suggestionMap : {};
      // console.log("vehicleData",this.vehicleData);
    const items = this.itemSet;
    if (items) {
      this.items = JSON.stringify(items);  // Parse the JSON string to an array
    }
    // console.log("this.item", this.items)
      }
      error => {

        this.aspLoadingService.hide();

        this.toastr.error(
          error?.error?.data?.description || 'Something went wrong',
          'Error'
        );

        setTimeout(() => {
          window.location.reload();
        }, 2000);

      }

    })
}
getSuggestionName(partName: string): string {
  const key = partName.trim().toLowerCase();
  const suggestion = this.suggestionMap[key];
  return suggestion?.name ?? partName;
}

isDifferentName(original: string, suggestion: string): boolean {
  return original.trim().toLowerCase() !== suggestion.trim().toLowerCase();
}

  getItemQuantity(name: string): number {
    const wishlist: { name: string, quantity: number }[] = this.itemSet;
    const existingItem = wishlist.find(w => w.name.toLowerCase() === name.toLowerCase());
    return existingItem ? existingItem.quantity : 1;
  }
   increaseQty(item: any): void {
    const name = item.name.trim();
    this.modifiedItems.add(name.toLowerCase());
    let wishlist: { name: string, quantity: number }[] = this.itemSet;
  
    const existingItem = wishlist.find(w => w.name.toLowerCase() === name.toLowerCase());
  
    if (existingItem) {
      existingItem.quantity += 1;
    } else {
      wishlist.push({ name, quantity: 1 });
    }
  
      this.itemSet=wishlist;
    // this.updateWishlistCount();
  }
  
  decreaseQty(item: any): void {
    const name = item.name.trim();
    this.modifiedItems.add(name.toLowerCase());
    let wishlist: { name: string, quantity: number }[] = this.itemSet
  
    const index = wishlist.findIndex(w => w.name.toLowerCase() === name.toLowerCase());
  
    if (index > -1) {
      // Decrease the quantity first
      wishlist[index].quantity -= 1;
      item.quantity = wishlist[index].quantity; // Update UI
  
      if (wishlist[index].quantity <= 0) {
        wishlist.splice(index, 1); // Remove item if quantity is 0
        item.inWishlist = false;   // Update UI state\
        const itemsArray = this.itemList.split(', ');

        // Remove the item
        const filteredArray = itemsArray.filter(item => item.trim() !== name);

        // Convert back to string
        this.itemList = filteredArray.join(', ');
        // console.log("itemList",this.itemList)
        
      }
  
      this.itemSet=wishlist;
      // this.wishItem();
      // this.getWishlist();
    }
  }
normalizeKeys(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map((item) => this.normalizeKeys(item));
  } else if (obj !== null && typeof obj === 'object') {
    const newObj: any = {};
    for (const key in obj) {
      newObj[key.toLowerCase()] = this.normalizeKeys(obj[key]);
    }
    return newObj;
  }
  return obj;
}

  goToMagicQuote(isExistFlow: boolean = true, ignoreValidation: boolean = false, reCreateRequest: boolean = false){
    // EDIT REQUEST FLOW
    if (this.isEditRequest) {
      this.updateRequestApi();
      return;
    }
    if (this.addMoreItemsId) {

      this.existingRequest = this.existingRequest || {};
      this.existingRequest.requestId =this.addMoreItemsId;
      // console.log("this.existingRequest.requestId", this.existingRequest.requestId,this.addMoreItemsId )
      this.updateExistingRequest();
    }else{
      // console.log("requst got hit from home page");
      // alert("got to flow magic flow")
      this.aspLoadingService.show();
      console.log('Raw itemSet used for request', JSON.stringify(this.itemSet));
      const correctedItemSet = this.itemSet.map(item => {
      return {
        ...item,
        suggestion: this.getSuggestionName(item.name)
      };
    });
    sessionStorage.setItem("instantQuote" ,JSON.stringify(correctedItemSet));
    sessionStorage.setItem("vehicleData" ,JSON.stringify(this.vehicleData));

    const responseData = this.suggestResponse.data;
    const responseDetails = this.suggestResponse.details;

    const items: any[] = [];
    const wrongPartNames: string[] = [];
correctedItemSet.forEach(part => {
  const suggestionKey = part.suggestion; // "Oil Filter"

  const dataExists =
    responseData.hasOwnProperty(suggestionKey) &&
    Array.isArray(responseData[suggestionKey]) &&
    responseData[suggestionKey].length > 0;

  if (dataExists) {

    // ✅ CORRECT quoteLineItemId lookup
    const quoteLineItemId =
      this.suggestResponse.details?.[suggestionKey]?.[suggestionKey] || 0;

    // 🔁 LOOP ALL PART TYPES (OEM + OES)
    responseData[suggestionKey].forEach((warehouseInfo: any) => {

      const rate =
        warehouseInfo?.zohoPartPrice?.length
          ? warehouseInfo.zohoPartPrice[0].rate
          : (warehouseInfo?.partInfo?.mrp || 0) / 100;

      const discount = warehouseInfo?.zohoPartPrice?.[0]?.discount || 0;
       this.suggestResponse.details = this.normalizeKeys(this.suggestResponse.details);
      const partNameKey = part.name?.toLowerCase();
        const suggestionKeyLower = suggestionKey?.toLowerCase();
          items.push({
          requestItemId: this.modifiedItems.has(suggestionKey.toLowerCase())
          ? this.getRequestItemId(suggestionKey)
          : null,
          partNumber: warehouseInfo?.partInfo?.partNumber,
          quoteLineItemId: this.suggestResponse.details?.[partNameKey]?.[suggestionKeyLower],
          partName: suggestionKey,
          quantity: part.quantity,
          availableStock: warehouseInfo?.warehouseInfo[0]?.warehouses[0]?.quantity_available_for_sale || warehouseInfo?.vendorInfo?.[0]?.stockCount ,
          partType: warehouseInfo?.partInfo?.partType, // OEM / OES
          brandName: warehouseInfo?.partInfo?.brand,
          mrp: rate,
          discount: discount,
          vendorId: warehouseInfo?.vendorInfo?.[0]?.vendorId || warehouseInfo?.warehouseInfo?.[0]?.warehouses?.[0]?.vendorId,
          deliveryTime: warehouseInfo?.partInfo?.deliveryTime || "",
          sellingPrice: rate - (rate * discount) / 100,
          inputName: part.name

    });
     });
  } else {
        // Add to items with empty values
        items.push({
         requestItemId: this.modifiedItems.has(suggestionKey.toLowerCase())
          ? this.getRequestItemId(suggestionKey)
          : null,
          partNumber: null,
          quoteLineItemId: 0,
          partName: suggestionKey,
          quantity: part.quantity,
          partType: null,
          brandName: null,
          mrp: 0.00,
          discount: 0.00,
          vendorId: 0,
          stockCount: 0,
          deliveryTime: null,
          availableStock:null,
          sellingPrice: 0.00,
            inputName:part.name
        });
        wrongPartNames.push(part.suggestion.replace(/,/g, ''));
      }
    });
    const userKey = localStorage.getItem('spareUserKey') || '';
    const requestBody: any = {
    "garageKey": localStorage.getItem("garageKey"),
      "wrongPartNames": wrongPartNames.join(', '),
      "variantKey": this.vehicleData.variantKey,
      "userType": "pitstopspare",
      "requestType": "web",
      "spareGarageId": localStorage.getItem("merchantId"),
      "regNo": (this.vehicleData?.registrationNumber || this.carNumber || '')
              .replace(/["\s]/g, ''),
      "manufacturingYear": this.vehicleData.year,
      "variant": this.vehicleData.variant,
      "vinNo": this.vehicleData.vin,
      "fuelType": this.vehicleData.fuel,
      "make": this.vehicleData.make,
      "model": this.vehicleData.model,
      "rowKey": this.vehicleData.rowKey,
      "items":items,
      "userKey": userKey,
      reCreateRequest: reCreateRequest,
      isInsurance:localStorage.getItem('isInsurance') === 'true' ? true
              : localStorage.getItem('isInsurance') === 'false' ? false
              : '',
      "insurerGarageKey":localStorage.getItem('insuranceGarageKey')=== 'null' ? null
                :!(localStorage.getItem('insuranceGarageKey'))? null
                :localStorage.getItem('insuranceGarageKey')

        };
        // console.log("request body of second part ",requestBody);

        if (ignoreValidation) {
          requestBody.ignoreValidation = true;
        }

        // console.log("Final request body ===>", requestBody);

        this.aspInstantOrderQuoteService.createQuotation(requestBody)
        .subscribe({
          next: (response:any) => {
            
        this.aspLoadingService.hide();
            this.response=response;
            if(response['code']== 200){
            // console.log("this.isPopupOpen=start;",this.isPopupOpen)
            this.isVisible=false;
            this.isOpenFull=false;
            this.openPartsEntry=false;
            this.openReview=false;
            const data = this.response['data'];
            this.spareRequestId = data?.spareRequest?.requestId || data?.requestId;
            this.uploadAllSpareImages();
            // console.log("Saved Request ID:", this.spareRequestId);
            this.isPopupOpen=true;
            this.isRequestExistsPopupOpen = false;
            // console.log("this.isPopupOpen=true;",this.isPopupOpen);
            
        localStorage.removeItem("isInsurance");
        localStorage.removeItem('insuranceGarageKey');
            // console.log("this.isPopupOpen=true;",this.isPopupOpen)
            // if (data?.quotationId) {
            //   // Navigate to magic quote with quotationId
            //   // this.router.navigate(['/magic-quote', data.quotationId]);

            // } else {
            //   this.popupContainer=true;
            // }
          // ✅ Only show popup if `isExistFlow` is TRUE
            if (isExistFlow && response.data?.existingRequest) {
            this.existingRequest = response.data.existingRequest;
            this.existingregistrationNumber = this.existingRequest.response.spareRequest['regNo'];
            // console.log("existingregistrationNumber-----",this.existingregistrationNumber);
            this.isRequestExistsPopupOpen = true; // Only show popup if existFlow
          } else {
              this.isPopupOpen = true; // Only open "fresh request" popup if you want normal flow
              // console.log('Fresh request - skipping exist popup flow');
          }
        } else if (response.code === 1103 || response.message?.includes('Spare request already exist')) {
          const match = response.data?.description?.match(/id\s*:\s*(\d+)/);
          this.existingRequestId = match?.[1];

          // console.log("========requestId", this.existingRequestId);

          if (this.existingRequestId) {
            // console.log("========requestId",this.existingRequestId)
            this.existingRequest = { 
              requestId: this.existingRequestId, 
              regNo: this.vehicleData?.registrationNumber, 
              items: [] ,
            };
            this.regNo = this.vehicleData?.registrationNumber;
            // console.log("this.regNo----",this.regNo);
            this.cdr.detectChanges();
            // console.log("========existingRequest================",this.existingRequest)
          }
            if (isExistFlow) {
              this.checkExistingRequest();
            } else {
              // console.log('Fresh request - skipping popup flow');
              this.isRequestExistsPopupOpen = false;
              this.isPopupOpen=true;
              this.toastr.error("REQUEST ALREADY EXIST");
            }
          // this.isRequestExistsPopupOpen = true;
          // Reset other flags
          this.isOpenFull = false;
          this.isVisible = false;
          this.openPartsEntry = false;
          this.openReview = false;

        } else {
          console.error('Unexpected response', response);
        }
      },
      error: (err) => {
        this.aspLoadingService.hide();
        console.error('Error creating quotation:', err);
      }
    });
      
    }
}
  requestSuccessPopup(){
  this.popupContainer=false;
  this.router.navigate(['my-request']); 
    // this.successPopup=true;
    // this.placeOrder=false;
  }
  tryAgain(){
              
    this.isVisible=true;
  this.popupContainer=false;
  }
  changeCar(){
    this.ngOnInit();
    this.openPartsEntry= false;
    this.isOpenFull=false;
    this.isVisible=true
  }

// searchText = '';

// filteredKits() {
//   return this.searchText
//     ? this.kits.filter(kit => kit.name.toLowerCase().includes(this.searchText.toLowerCase()))
//     : this.kits;
// }

// toggleSelectAll() {
//   this.selectedKits = this.isAllSelected() ? [] : [...this.kits];
// }

// isAllSelected() {
//   return this.selectedKits.length === this.kits.length;
// }

// resetKits() {
//   this.selectedKits = [];
//   this.searchText = '';
// }
openCustomPanel = false;
searchText: string = '';

filteredKits() {
  return this.kits.filter(kit =>
    kit.name.toLowerCase().includes(this.searchText.toLowerCase())
  );
}

toggleKitSelection(kit: any) {
  const index = this.selectedKits.indexOf(kit);
  if (index > -1) this.selectedKits.splice(index, 1);
  else this.selectedKits.push(kit);
  this.onKitsChanged()
}

isAllSelected() {
  
   this.onKitsChanged()
  return this.selectedKits.length === this.kits.length;
}

toggleSelectAll() {
  this.selectedKits = this.isAllSelected() ? [] : [...this.kits];
}

resetKits() {
  this.selectedKits = [];
  this.searchText = '';
}
ok(){
  this.openCustomPanel = false;
 this.searchText = '';
}
openKits(){
  this.scrollToTarget();
  this.openCustomPanel = true
}
@ViewChild('myTargetDiv') myTargetDiv!: ElementRef;

  scrollToTarget() {
    this.myTargetDiv.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }

    openModal(part) {
      // console.log("part", part)
    this.showModal = true;
    this.searchTextName = '';
    // this.filteredSuggestions = [];
    // this.selectedMode = null;
    this.asTypedPart=part;
    this.searchTextName= this.getSuggestionName(part.name);
    this.filterSuggestions()
  }
  asTyped(){
    this.searchTextName = this.asTypedPart.name;
    this.filterSuggestions()
  }
  cancelName(){
    this.searchTextName = '';
    this.filterSuggestions()
  }
  filterSuggestions() {
  if (this.searchTextName && this.searchTextName.length >= 3) {
    
    this.searchTextShow=true;
      let rowKey = localStorage.getItem('rowKey');
      
      let universal = false;
      let variantKey = localStorage.getItem('variantKey');
      // console.log("searchText",this.searchText);
      this.searchSuggestionService.getSearchSuggestions(this.vehicleData.rowKey, this.searchTextName, universal, this.vehicleData.variantKey).subscribe(
          result => {

// console.log("result", result);
              this.suggestions = [];
              // if (result['data'].brands && result['data'].brands.length > 0)
              //     this.suggestions.push(...result['data'].brands.map((value: string) => ({ value, type: 'brand' })));
              // if (result['data'].categories && result['data'].categories.length > 0)
              //     this.suggestions.push(...result['data'].categories.map((value: string) => ({ value, type: 'category' })));
              if (result['data'].partNames && result['data'].partNames.length > 0)
                  this.suggestions.push(...result['data'].partNames.map((value: string) => ({ value, type: 'partName' })));
              // if (result['data'].partNumbers && result['data'].partNumbers.length > 0)
              //     this.suggestions.push(...result['data'].partNumbers.map((value: string) => ({ value, type: 'partNumber' })));

              this.suggestions.reverse();
              // Sort suggestions based on relevance
              this.suggestions = this.sortSuggestionsByRelevance(this.suggestions, this.searchText);

          }
      );
  } else {
      this.suggestions = [];
  }
}
sortSuggestionsByRelevance(suggestions: { value: string, type: string }[], searchText: string): { value: string, type: string }[] {
  const typePriority = {
      brand: 4,
      category: 3,
      partName: 2,
      partNumber: 1,
  };

  return suggestions?.sort((a, b) => {
      const relevanceA = this.getRelevance(a.value, searchText) + typePriority[a.type];
      const relevanceB = this.getRelevance(b.value, searchText) + typePriority[b.type];

      return relevanceB - relevanceA; 
  });
}
getRelevance(suggestion: string, searchText: string): number {
  if (suggestion?.toLowerCase() === searchText?.toLowerCase()) {
      return 3; 
  } else if (suggestion?.toLowerCase().startsWith(searchText?.toLowerCase())) {
      return 2; 
  } else if (suggestion?.toLowerCase().includes(searchText?.toLowerCase())) {
      return 1; 
  } else {
      return 0; 
  }
}
getHighlightedText(text: any, search: any): string {
  if (typeof text !== 'string' || typeof search !== 'string') {
      // Handle cases where text or search is not a string
      return text;
  }

  if (!search) {
      return text; // Return original text if no search term
  }

  const parts = text.split(new RegExp(`(${search})`, 'gi'));
  return parts.map(part => part.toLowerCase() === search.toLowerCase()
      ? `<span class="highlight">${part}</span>`
      : part
  ).join('');
}
selectSuggestion(SuggestionName){
  // console.log("SuggestionName",SuggestionName)
  this.searchTextName=SuggestionName.value;
  this.searchTextShow=false;
  this.selectedSuggestion=SuggestionName.value;
  this.filterSuggestions()
}
saveItem(){
  // if(this.searchTextName.length>0){
  //   const listArray = this.itemList.split(',').map(item => item.trim());

  //   const updatedArray = listArray.map(item =>
  //     item.toLowerCase() === this.asTypedPart.name.toLowerCase()
  //       ? this.searchTextName
  //       : item
  //   );


  //   this.itemList = updatedArray.join(', ');
    // console.log(" this.itemList", this.itemList)
    // console.log(" this.searchTextName", this.searchTextName)
    // console.log(" this.asTypedPart", this.asTypedPart)
  //   this.reviewParts(true);
  // }
  // console.log("this.suggestions",this.suggestions);
  const match =  this.suggestions.some(
  part => part.value.trim().toLowerCase() === this.searchTextName.trim().toLowerCase()
);
  if ((this.selectedSuggestion == this.searchTextName)|| match) {
        if(this.searchTextName.length>0){
          const trimmedOldName = this.asTypedPart.name.trim().toLowerCase();
        const trimmedNewName = this.searchTextName.trim();
      if (this.suggestionMap.hasOwnProperty(trimmedOldName)) {
      delete this.suggestionMap[trimmedOldName];
        }

        // Find the item by old name
        const itemIndex = this.itemSet.findIndex(
          item => item.name.trim().toLowerCase() === trimmedOldName
        );
        if (itemIndex !== -1) {
          // Update the name
          this.itemSet[itemIndex].name = trimmedNewName;
        } else {
          console.warn(`Item with name "${this.asTypedPart.name}" not found.`);
        }
      }
        this.showModal = false;
  }else{
    this.toastr.error("Please pick from suggestions");
  }
}
closeModal(){
   this.showModal = false;
}

  // For request exists popup

// Close popup
closeRequestExistsPopup() {
  this.isRequestExistsPopupOpen = false;
  this.existingRequest = null;
}

// Actions
// startFreshRequest() {
//   this.closeRequestExistsPopup();
//   this.isVisible = true;
//   this.openPartsEntry = false;
//   this.isOpenFull = false;
// }
// ====================
// startFreshRequest() {
//   this.toastr.info('Starting a new request...');
//   this.clearLocalStorage(); // optional
//   this.goToMagicQuote();
// }

updateExistingRequest() {
    const fallbackRequestId = this.existingRequest?.requestId; // ✅ STORE SAFE COPY
  if (!this.existingRequest?.requestId) {
    this.toastr.error("No request selected for update");
    return;
  }

    this.aspLoadingService.show();
 const correctedItemSet = this.itemSet.map(item => {
    return {
      ...item,
      suggestion: this.getSuggestionName(item.name)
    };
  });
  sessionStorage.setItem("instantQuote" ,JSON.stringify(correctedItemSet));
  sessionStorage.setItem("vehicleData" ,JSON.stringify(this.vehicleData));

  const responseData = this.suggestResponse.data;
  const responseDetails = this.suggestResponse.details;

  const items: any[] = [];
  const wrongPartNames: string[] = [];
correctedItemSet.forEach(part => {
  const suggestionKey = part.suggestion; // "Oil Filter"

  const dataExists =
    responseData.hasOwnProperty(suggestionKey) &&
    Array.isArray(responseData[suggestionKey]) &&
    responseData[suggestionKey].length > 0;

  if (dataExists) {

    // ✅ CORRECT quoteLineItemId lookup
    const quoteLineItemId =
      this.suggestResponse.details?.[suggestionKey]?.[suggestionKey] || 0;

    // 🔁 LOOP ALL PART TYPES (OEM + OES)
    responseData[suggestionKey].forEach((warehouseInfo: any) => {

      const rate =
        warehouseInfo?.zohoPartPrice?.length
          ? warehouseInfo.zohoPartPrice[0].rate
          : (warehouseInfo?.partInfo?.mrp || 0) / 100;

      const discount = warehouseInfo?.zohoPartPrice?.[0]?.discount || 0;
       this.suggestResponse.details = this.normalizeKeys(this.suggestResponse.details);
      const suggestionKeyLower = suggestionKey?.toLowerCase();
      const partNameKey = part.name?.toLowerCase();

      items.push({
        requestItemId: this.modifiedItems.has(suggestionKey.toLowerCase())
          ? this.getRequestItemId(suggestionKey)
          : null,
        partNumber: warehouseInfo?.partInfo?.partNumber,
        quoteLineItemId: this.suggestResponse.details?.[partNameKey]?.[suggestionKeyLower],
        partName: suggestionKey,
        quantity: part.quantity,
        partType: warehouseInfo?.partInfo?.partType, // OEM / OES
        brandName: warehouseInfo?.partInfo?.brand,
        mrp: rate,
        discount: discount,
        availableStock: warehouseInfo?.warehouseInfo[0]?.warehouses[0]?.quantity_available_for_sale || warehouseInfo?.vendorInfo?.[0]?.stockCount ,
        vendorId: warehouseInfo?.vendorInfo?.[0]?.vendorId || warehouseInfo?.warehouseInfo?.[0]?.warehouses?.[0]?.vendorId,
        deliveryTime: warehouseInfo?.partInfo?.deliveryTime || "",
        sellingPrice: rate - (rate * discount) / 100,
        inputName: part.name
      });

    });

  } else {

    // ❌ No data case (unchanged)
    items.push({
      requestItemId: this.modifiedItems.has(suggestionKey.toLowerCase())
          ? this.getRequestItemId(suggestionKey)
          : null,
      partNumber: null,
      quoteLineItemId: 0,
      partName: suggestionKey,
      quantity: part.quantity,
      partType: null,
      brandName: null,
      mrp: 0.0,
      discount: 0.0,
      vendorId: 0,
      stockCount:0,
      deliveryTime: null,
      sellingPrice: 0.0,
      inputName: part.name
    });

    wrongPartNames.push(suggestionKey.replace(/,/g, ''));
  }
});


  const requestBody = {
    garageKey: localStorage.getItem("garageKey"),
    wrongPartNames: wrongPartNames.join(', '), 
    variantKey: this.vehicleData.variantKey,
    userType: "pitstopspare",
    requestType: "web",
    spareGarageId: localStorage.getItem("merchantId"),
    regNo: (this.vehicleData?.registrationNumber || this.carNumber || '').replace(/["\s]/g, ''),
    manufacturingYear: this.vehicleData.year,
    variant: this.vehicleData.variant,
    vinNo: this.vehicleData.vin,
    fuelType: this.vehicleData.fuel,
    make: this.vehicleData.make,
    model: this.vehicleData.model,
    rowKey: this.vehicleData.rowKey,
    items: items,
    requestId: this.existingRequest.requestId,   
    isExistRequest: true,                        
    userKey: localStorage.getItem('spareUserKey'),
    isInsurance:localStorage.getItem('isInsurance') === 'true' ? true
             : localStorage.getItem('isInsurance') === 'false' ? false
             : '',
     "insurerGarageKey":localStorage.getItem('insuranceGarageKey')=== 'null' ? null
              :!(localStorage.getItem('insuranceGarageKey'))? null
              :localStorage.getItem('insuranceGarageKey')
  };
  // console.log("request body of vehicle registration number ,",requestBody);

  this.aspInstantOrderQuoteService.createQuotation(requestBody)
    .subscribe({
      next: (response: any) => {
        this.aspLoadingService.hide();
        if (response.code === 200) {
          
          this.isOpenFull = false;
          this.isVisible = false;
          this.openPartsEntry = false;
          this.openReview = false;
            this.updatePopupData = response.data; 

            this.toastr.success('Request updated successfully');
            this.spareRequestId = response.data?.spareRequest?.requestId || fallbackRequestId;
            if (this.selectedImages?.length > 0) {
              this.uploadAllSpareImages();
            }
            this.closeRequestExistsPopup();
            this.isRequestExistsPopupOpen = false;
            this.existingRequest = null; // safe to clear now
            // optionally navigate or refresh list
            this.isPopupOpen = true;
            // console.log("popup",this.isPopupOpen)
            // this.router.navigate(['my-request']);
            
      localStorage.removeItem("isInsurance");
      localStorage.removeItem('insuranceGarageKey');
        } 
        else {
          this.toastr.error(response.message || 'Update failed');
        }
      },
      error: (err) => {
        this.aspLoadingService.hide();
        console.error('Update error:', err);
        this.toastr.error('Something went wrong');
      }
    });
}

// updateExistingRequest() {
//   if (!this.existingRequest?.requestId) {
//     this.toastr.error("No request selected for update");
//     return;
//   }

//   this.aspLoadingService.show();

//   // 1️⃣ Prepare new items with suggestion
//   const newItems = this.itemSet.map(item => ({
//     ...item,
//     suggestion: this.getSuggestionName(item.name)
//   }));

//   sessionStorage.setItem("instantQuote", JSON.stringify(newItems));
//   sessionStorage.setItem("vehicleData", JSON.stringify(this.vehicleData));

//   // 2️⃣ Prepare existing items from previous request
//   const existingItems = (this.existingRequest.response?.body?.spareRequestItemList || []).map(item => ({
//     partNumber: item.partNumber || null,
//     quoteLineItemId: item.lineitemId || 0,
//     partName: item.itemName,
//     quantity: item.itemQuantity,
//     partType: null,
//     brandName: null,
//     mrp: item.mrp || 0,
//     discount: item.discount || 0,
//     vendorId: item.merchantId || 0,
//     deliveryTime: null,
//     sellingPrice: item.biddedPrice || 0,
//     inputName: item.wrongName || item.itemName
//   }));

//   // 3️⃣ Merge existing + new items
//   const mergedItemsMap: { [key: string]: any } = {};

//   existingItems.forEach(item => {
//     const key = (item.inputName || item.partName || '').trim().toLowerCase();
//     if (key) mergedItemsMap[key] = { ...item };
//   });

//   newItems.forEach(item => {
//     const key = (item.name || item.suggestion || '').trim().toLowerCase();
//     if (!key) return;

//     const partNameKey = item.name?.toLowerCase();
//     const suggestionKeyLower = item.suggestion?.toLowerCase();

//     // ✅ Pick first available warehouse info (like goToMagicQuote)
//     const warehouseArray = this.suggestResponse.data?.[partNameKey] || [];
//     const warehouseInfo = warehouseArray[0];

//     // Normalize details
//     this.suggestResponse.details = this.normalizeKeys(this.suggestResponse.details);

//     if (mergedItemsMap[key]) {
//       mergedItemsMap[key] = {
//         ...mergedItemsMap[key],
//         quantity: mergedItemsMap[key].quantity + item.quantity,
//         partName: item.suggestion,
//         inputName: item.name,
//         // Update other fields from warehouse if available
//         partNumber: warehouseInfo?.partInfo?.partNumber || mergedItemsMap[key].partNumber,
//         partType: warehouseInfo?.partInfo?.partType || mergedItemsMap[key].partType,
//         brandName: warehouseInfo?.partInfo?.brand || mergedItemsMap[key].brandName,
//         mrp: warehouseInfo?.zohoPartPrice?.[0]?.rate
//           ? warehouseInfo.zohoPartPrice[0].rate
//           : (warehouseInfo?.partInfo?.mrp || mergedItemsMap[key].mrp) / 100,
//         discount: warehouseInfo?.zohoPartPrice?.[0]?.discount || mergedItemsMap[key].discount,
//         vendorId: warehouseInfo?.vendorInfo?.[0]?.vendorId
//           || warehouseInfo?.warehouseInfo?.[0]?.warehouses?.[0]?.vendorId
//           || mergedItemsMap[key].vendorId,
//         deliveryTime: warehouseInfo?.partInfo?.deliveryTime || mergedItemsMap[key].deliveryTime,
//         sellingPrice: warehouseInfo?.zohoPartPrice?.[0]?.rate
//           ? warehouseInfo.zohoPartPrice[0].rate - ((warehouseInfo.zohoPartPrice[0].rate * (warehouseInfo.zohoPartPrice[0].discount || 0)) / 100)
//           : (warehouseInfo?.partInfo?.mrp || mergedItemsMap[key].sellingPrice) / 100
//       };
//     } else {
//       mergedItemsMap[key] = {
//         partNumber: warehouseInfo?.partInfo?.partNumber || null,
//         quoteLineItemId: this.suggestResponse.details?.[partNameKey]?.[suggestionKeyLower] || 0,
//         partName: item.suggestion,
//         quantity: item.quantity,
//         partType: warehouseInfo?.partInfo?.partType || null,
//         brandName: warehouseInfo?.partInfo?.brand || null,
//         mrp: warehouseInfo?.zohoPartPrice?.[0]?.rate
//           ? warehouseInfo.zohoPartPrice[0].rate
//           : (warehouseInfo?.partInfo?.mrp || 0) / 100,
//         discount: warehouseInfo?.zohoPartPrice?.[0]?.discount || 0,
//         vendorId: warehouseInfo?.vendorInfo?.[0]?.vendorId
//           || warehouseInfo?.warehouseInfo?.[0]?.warehouses?.[0]?.vendorId || 0,
//         deliveryTime: warehouseInfo?.partInfo?.deliveryTime || "",
//         sellingPrice: warehouseInfo?.zohoPartPrice?.[0]?.rate
//           ? warehouseInfo.zohoPartPrice[0].rate - ((warehouseInfo.zohoPartPrice[0].rate * (warehouseInfo.zohoPartPrice[0].discount || 0)) / 100)
//           : (warehouseInfo?.partInfo?.mrp || 0) / 100,
//         inputName: item.name
//       };
//     }
//   });

//   // 4️⃣ Prepare request body
//   const requestBody = {
//     garageKey: localStorage.getItem("garageKey"),
//     wrongPartNames: '',
//     variantKey: this.vehicleData.variantKey,
//     userType: "pitstopspare",
//     requestType: "web",
//     spareGarageId: localStorage.getItem("merchantId"),
//     regNo: (this.vehicleData?.registrationNumber || this.carNumber || '').replace(/["\s]/g, ''),
//     manufacturingYear: this.vehicleData.year,
//     variant: this.vehicleData.variant,
//     vinNo: this.vehicleData.vin,
//     fuelType: this.vehicleData.fuel,
//     make: this.vehicleData.make,
//     model: this.vehicleData.model,
//     rowKey: this.vehicleData.rowKey,
//     items: Object.values(mergedItemsMap),
//     requestId: this.existingRequest.requestId,
//     isExistRequest: true,
//     userKey: localStorage.getItem('spareUserKey')
//   };

  // console.log('Final payload sent to API ===>', requestBody);

//   // 5️⃣ Call API
//   this.aspInstantOrderQuoteService.createQuotation(requestBody)
//     .subscribe({
//       next: (response: any) => {
//         this.aspLoadingService.hide();
//         if (response.code === 200) {
//           this.isPopupOpen = true;
//           this.toastr.success("Request updated successfully!");
//           this.closeRequestExistsPopup();
//           this.router.navigate(['my-request']);
//         } else {
//           this.toastr.error(response.message || "Failed to update request");
//         }
//       },
//       error: (err) => {
//         this.aspLoadingService.hide();
//         console.error('Error updating request:', err);
//         this.toastr.error("Something went wrong");
//       }
//     });
// }

hasMoreItems(): boolean {
  return this.existingRequest?.response?.body?.spareRequestItemList?.length > 3;
}
get existingRequestItems() {
  return this.existingRequest?.response?.body?.spareRequestItemList || [];
}

// Show up to 3 items by default
getVisibleItems(items: any[]) {
  return this.showFullItems ? items : items.slice(0, 3);
}

toggleFullItems() {
  this.showFullItems = !this.showFullItems;
}
checkExistingRequest() {
  const spareGarageId = localStorage.getItem('merchantId');
  // console.log("this.existingRequestId ====", this.existingRequestId);

  if (!spareGarageId && !this.existingRequestId) {
    console.warn('Missing spareGarageId or requestId');
    return;
  }

  this.aspLoadingService.show();

  this.aspInstantOrderQuoteService
    .getSpareRequest('pitstopSpare', spareGarageId, this.existingRequestId)
    .subscribe({
      next: (response: any) => {
        this.aspLoadingService.hide();
        // console.log('Existing Request API Response===============:', response);

        if (response) {
          // assign the whole response, not response['data']
          this.existingRequest = response;
          // console.log("this.existingRequest---", this.existingRequest);
          this.isRequestExistsPopupOpen = true;
        } else {
          this.toastr.error(response?.message || 'Something went wrong.');
        }
      },
      error: (err) => {
        this.aspLoadingService.hide();
        console.error('API Error:', err);
        this.toastr.error('Failed to fetch request details.');
      },
    });
}
getOverallStatus(items: any[]): string {
  if (!items || items.length === 0) return '⏳ Requested';

  // Define priority (higher in array = higher priority)
  const priorityOrder = ['4', '10', '9', '8', '1']; 
  // Order Created > Quote Approved > Quote Received > Requested

  // Extract all statuses present in items
  const statusSet = items.map(i => i.status.toString());

  // Find the **highest priority status** present in the items
  for (const status of priorityOrder) {
    if (statusSet.includes(status)) {
      switch (status) {
        case '4':
        case '10':
          return '📦 Order Created';
        case '9':
          return '✅ Quote Approved';
        case '8':
          return '💬 Quote Received';
        case '1':
          return '⏳ Requested';
      }
    }
  }

  return '⏳ Requested'; // fallback
}

getCreatedDate(gmtDate: string | null | undefined): string {
  if (!gmtDate || gmtDate === 'NA') {
    return 'NA';
  }

  // Treat backend time as UTC by appending ' UTC'
  const utcDate = new Date(gmtDate + ' UTC');

  // Now convert to IST automatically using locale
  const options: Intl.DateTimeFormatOptions = { 
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit', hour12: true,
    timeZone: 'Asia/Kolkata' // Convert to IST
  };

  return utcDate.toLocaleString('en-IN', options);
}

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      return;
    }

    const files = Array.from(input.files);

    for (const file of files) {

      // 🔒 Allow only images
      if (!file.type || !file.type.startsWith('image/')) {
        continue;
      }

      // 🔁 Avoid duplicates
      const exists = this.selectedImages.some(
        img =>
          img.name === file.name &&
          img.size === file.size &&
          img.lastModified === file.lastModified
      );

      if (exists) {
        continue;
      }

      this.selectedImages.push(file);

      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreviews.push(reader.result as string);
      };
      reader.readAsDataURL(file);
    }

    // Reset input
    input.value = '';
  }

  removeImage(index: number): void {
    this.selectedImages.splice(index, 1);
    this.imagePreviews.splice(index, 1);
  }
  uploadAllSpareImages() {
    // console.log("uploadAllSpareImages called");

    if (!this.spareRequestId || this.selectedImages.length === 0) {
      // console.log("❌ No images selected — upload stopped");
      return;
    }

    const garageKey = localStorage.getItem("garageKey") || '';
    if (!garageKey) {
      this.toastr.error("Garage key not found");
      return;
    }

    // 🔥 Create API call array
    const uploadCalls = this.selectedImages.map(file =>
      this.aspInstantOrderQuoteService.uploadSpareRequestImage(
        this.spareRequestId,
        garageKey,
        file
      )
    );

    // 🚀 Wait for ALL uploads to finish
    forkJoin(uploadCalls).subscribe({
      next: (responses) => {
        // console.log("✅ All images uploaded", responses);
        this.toastr.success("All images uploaded successfully");

        // ✅ Now clear AFTER success
        this.selectedImages = [];
        this.imagePreviews = [];
      },
      error: (err) => {
        console.error("❌ Some uploads failed", err);
        this.toastr.error("Some images failed to upload");
      }
    });
  }
openImagePreview(url: string) {
  this.previewImageUrl = url;
  this.imagePreviewOpen = true;
}

closeImagePreview() {
  this.imagePreviewOpen = false;
  this.previewImageUrl = null;
}
  closePopup(){
    localStorage.removeItem('carNumber');
    localStorage.removeItem('selectedMake');
    localStorage.removeItem('selectedModel');
    localStorage.removeItem('variant');
    localStorage.removeItem('fuelType');
    localStorage.removeItem('selectedYear');
    localStorage.removeItem('variantKey');
    localStorage.removeItem('rowKey');
    localStorage.removeItem('addMoreItemsId');
    this.isPopupOpen = false;
    this.activeUrl = this.router.url;
    this.isRequestDetails = this.activeUrl.includes('/my-request');
    this.isRequestDetailsPage = this.activeUrl.includes('/request-details');
    if (this.isRequestDetails || this.isRequestDetailsPage){
      window.location.reload();
    }else{
    this.router.navigate(['my-request']);
    }
  }
goToRequestDetails(spareRequestId: string) {
  localStorage.removeItem('carNumber');
  localStorage.removeItem('selectedMake');
  localStorage.removeItem('selectedModel');
  localStorage.removeItem('variant');
  localStorage.removeItem('fuelType');
  localStorage.removeItem('selectedYear');
  localStorage.removeItem('variantKey');
  localStorage.removeItem('rowKey');
  localStorage.removeItem('addMoreItemsId');
  this.isPopupOpen = false;
   const activeUrl = this.router.url;

  if (activeUrl.includes('/request-details')) {
    window.location.reload();
  } else {
    this.router.navigate(['/request-details'], {
      queryParams: { id: spareRequestId }
    }).then(() => {
      window.location.reload();
    });
  }
}
// =================locked items popup=============
  // openLockedPopup() {
  //   this.isLockedPopupOpen = true;
  // }
  openLockedPopup(part: any) {
  this.selectedLockedPart = part;
  this.isLockedPopupOpen = true;
}

  closeLockedPopup() {
    this.isLockedPopupOpen = false;
  }
  isPartLocked(part: any): boolean {
    return this.lockedItemNames?.has(part.name?.toLowerCase());
  }
  isCancelledPart(part: any): boolean {
    return this.requestItems?.some(
    item =>
      item.itemName?.toLowerCase() ===
      this.getSuggestionName(part.name)?.toLowerCase() &&
      item.status === 0
  );
  }
  getOrderedItems(): string[] {
    return Array.from(this.lockedItemNames);
  }
  deletePart(index: number) {
  console.log('Clicked Index:', index);
  console.log('itemSet', this.itemSet);
  console.log('requestItems', this.requestItems);

    // Show popup when only one item remains
    if (this.itemSet?.length === 1) {
      this.lastItemDeleteIndex = index;
      this.lastItemName = this.getSuggestionName(this.itemSet[index]?.name || '');
      this.showLastItemDeletePopup = true;
      return;
    }
    const item = this.requestItems[index];

    if (item?.status === 0) {
      return;
    }

    this.deleteItemApi(index);
  }
  closeLastItemDeletePopup() {
    this.showLastItemDeletePopup = false;
    this.lastItemDeleteIndex = null;
  }

  confirmDeleteLastItem() {

    if (this.lastItemDeleteIndex === null) {
      return;
    }

    this.showLastItemDeletePopup = false;

    this.deleteItemApi(this.lastItemDeleteIndex);
  }
  deleteItemApi(index: number) {
    const item = this.requestItems[index];

    if (!item || !item.id) {
      console.warn('Item not found or missing id at index', index);
      return;
    }
    const requestIdToUse = this.addMoreItemsId || item.requestId;
    const payload = {
      garageKey: localStorage.getItem('garageKey'),
      requestId: this.addMoreItemsId || item.requestId,
      cancelItem: [
        {
          itemId: String(item.id),
          itemName: item.itemName
        }
      ],
      requestLevel: false
    };
    
    this.aspInstantOrderQuoteService.cancelSpareRequest(payload).subscribe({
      next: (res) => {

        this.cancelledRequestId = requestIdToUse;
        this.cancelledItemName = item.itemName;

        // Remove from UI
        this.itemSet = this.itemSet.filter(function (part) {
          return (
            part.name?.toLowerCase() !==
            item.itemName?.toLowerCase()
          );
        });

        this.requestItems = this.requestItems.filter(function (requestItem) {
          return requestItem.id !== item.id;
        });

        // Show success popup
        this.showRequestCancelSuccessPopup = true;
      },
      error: (err) => {
        console.error('Cancel failed', err);
      }
    });
  }
  getRequestItemId(partName: string): number | null {
  const item = this.requestItems?.find(function (requestItem) {
    return (
      requestItem.itemName?.trim().toLowerCase() ===
      partName?.trim().toLowerCase()
    );
  });

  return item?.id || null;
}
  closeRequestCancelSuccessPopup() {
    this.showRequestCancelSuccessPopup = false;
    window.location.reload();
  }
  updateRequestApi() {

  if (!this.addMoreItemsId) {
    this.toastr.error('Request ID missing');
    return;
  }

  this.aspLoadingService.show();

  const requestItems = this.itemSet.map(part => {

  const requestItem = this.requestItems?.find(
    x =>
      x.itemName?.toLowerCase() ===
      this.getSuggestionName(part.name)?.toLowerCase()
  );

  return {
    itemId: String(requestItem?.id),
    quantity: String(part.quantity || 1)
  };

}).filter(x => x.itemId);

  const payload = {
    requestId: String(this.addMoreItemsId),
    garageKey: localStorage.getItem('garageKey'),
    variantKey: this.vehicleData?.variantKey,
    userType: 'pitstopspare',
    requestType: 'web',
    spareGarageId: Number(localStorage.getItem('merchantId')),
    regNo: this.vehicleData?.registrationNumber,
    manufacturingYear: this.vehicleData?.year || '',
    variant: this.vehicleData?.variant,
    vinNo: this.vehicleData?.vin,
    fuelType: this.vehicleData?.fuel,
    make: this.vehicleData?.make,
    model: this.vehicleData?.model,
    rowKey: this.vehicleData?.rowKey,
    requestItems: requestItems,
    source: 'web'
  };

  console.log('Update Request Payload', payload);

  this.aspInstantOrderQuoteService.updateRequest(payload)
  .subscribe({
    next: (response: any) => {

      this.aspLoadingService.hide();

      if (response.code === 200) {

        this.toastr.success('Request updated successfully');

        this.isVisible = false;
        this.isOpenFull = false;
        this.openPartsEntry = false;
        this.openReview = false;

        this.isPopupOpen = true;

      } else {
        this.toastr.error(response.message || 'Update failed');
      }
    },
    error: (err) => {
      this.aspLoadingService.hide();
      console.error(err);
      this.toastr.error('Update failed');
    }
  });
}
}
